import React, { FC, memo } from 'react';
import { Card } from '@material-ui/core';
import { Partnership } from '../../../../models';
import { useStyles } from './styles';

interface PartnershipCardProps {
  partnership: Partnership;
}

export const PartnershipCard: FC<PartnershipCardProps> = memo(({ partnership }) => {
  const classes = useStyles();

  return (
    <Card key={partnership.id} className={classes.partnershipCard}>
      {partnership.partnershipCode}
    </Card>
  );
});
